import * as tslib_1 from "tslib";
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule, MatIconModule, MatInputModule, MatMenuModule, MatProgressSpinnerModule, MatSnackBarModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ExtendzFileUploadComponent } from './extendz-file-upload.component';
import { ExtendPipesModule, ExtendzRestModule, ExtendzDirectiveModule } from '../../common/';
var ExtendzFileUploadModule = /** @class */ (function () {
    function ExtendzFileUploadModule() {
    }
    ExtendzFileUploadModule = tslib_1.__decorate([
        NgModule({
            imports: [
                CommonModule,
                FlexLayoutModule,
                // Extendz
                ExtendPipesModule,
                ExtendzRestModule,
                ExtendzDirectiveModule,
                // Mat
                MatButtonModule,
                MatSnackBarModule,
                MatMenuModule,
                MatIconModule,
                MatProgressSpinnerModule,
                MatInputModule
            ],
            declarations: [ExtendzFileUploadComponent],
            exports: [ExtendzFileUploadComponent]
        })
    ], ExtendzFileUploadModule);
    return ExtendzFileUploadModule;
}());
export { ExtendzFileUploadModule };
//# sourceMappingURL=extendz-file-upload.module.js.map